let initialize = ''

function hotjar(...args) {
  if (process.env.NODE_ENV !== 'production' || initialize !== '') {
    return
  }
  if (typeof window.hj !== 'function') {
    let retry = 0
    const interval = setInterval(() => {
      if (initialize === 'done') {
        clearInterval(interval)
        window.hj(...args)
      } else if (retry === 5) {
        clearInterval(interval)
      } else {
        retry += 1
      }
    }, 1000)
  } else {
    window.hj(...args)
  }
}

export function setup(...args) {
  if (process.env.NODE_ENV !== 'rails') {
    return
  }
  initialize = 'initializing'
  /* eslint-disable */
  ;(function(h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function() {
        ;(h.hj.q = h.hj.q || []).push(...args)
      }
    h._hjSettings = {
      hjid: 613796,
      hjsv: 5,
    }
    a = o.getElementsByTagName('head')[0]
    r = o.createElement('script')
    r.async = 1
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
    a.appendChild(r)

    initialize = 'done'
  })(window, document, '//static.hotjar.com/c/hotjar-', '.js?sv=')
  /* eslint-enable */
}

export function stateChange(path) {
  hotjar('stateChange', path)
}

export default {
  setup,
  stateChange,
}



// WEBPACK FOOTER //
// ./src/services/hotjar.js